const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getPermissions = async () => {
  const token = localStorage.getItem('token');

  if (!token) {
    console.error('[getPermissions] Error: Authorization token not found.');
    // throw new Error('Authorization token not found.'); 
  }

  try {
    const response = await fetch(`${API_BASE_URL}/admin/user/permissions`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('[getPermissions] Error fetching permissions:', errorData);
      throw { ...errorData, statusCode: response.status };
    }

    const data = await response.json();
    console.log(data)
    return data;
  } catch (error) {
    console.error('[getPermissions] Network error or other issue while fetching permissions:', error);
    throw error;
  }
};